import React, { useEffect, useState, useCallback } from "react";
import { useHandleScroll } from "@/hooks";
import { polyfill } from "smoothscroll-polyfill";
import { useTranslation } from "react-i18next";
import { MainLayout } from "@/layouts";
import { MainHome, MissionScreen } from "@/pagePartials/home";
import "animate.css";
import ServiceOverviewScreen from "@/pagePartials/home/serviceOverview/ServiceOverviewScreen";
import OurGoal from "@/pagePartials/home/goal/OurGoal";
import FreeTrialScreen from "@/pagePartials/home/freeTrial/FreeTrialScreen";
import BenefitsScreen from "@/pagePartials/home/benefits/BenefitsScreen";
import HowItWorks from "@/pagePartials/home/functioning/HowItWorks";
import HelpSection from "@/pagePartials/home/help/HelpSection";

export default function Home() {
  const { t } = useTranslation("global");
  const { selecteditem, handleScroll } = useHandleScroll();
  useEffect(() => {
    polyfill();
  }, []);

  const listenScroll = useCallback(
    (event: any) => {
      requestAnimationFrame(() => {
        handleScroll(event);
      });
    },
    [handleScroll]
  );

  useEffect(() => {
    window.addEventListener("scroll", listenScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", listenScroll);
    };
  }, [listenScroll]);

  return (
    <MainLayout title="Cellect Energy Home" description="Home page Cellect Energy" navbarTheme="dark">
      <MainHome selecteditem={selecteditem} />
      <MissionScreen selecteditem={selecteditem} />
      <ServiceOverviewScreen />
      <OurGoal selecteditem={selecteditem} />
      <FreeTrialScreen />
      <BenefitsScreen selecteditem={selecteditem} />
      <HowItWorks selecteditem={selecteditem} />
      <HelpSection />
    </MainLayout>
  );
}
